import React, { useState } from 'react';

function TaskContextInTheory({ user_id, theoryData, task_number, code, course_name }) {
    const [close_information, setCloseInformation] = useState(false)
    const askAboutTask = async (task_number, code) => {
        try {
          const response = await fetch('api/chat/add-task-in-theory-context', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              user_id: user_id,
              topic: theoryData.topic,
              task_number: task_number,
              code: code,
              course_name: course_name,
            }),
          });
          setCloseInformation(true)
        } catch (err) {
          console.error(err.message);
        }
      }

      const closeInformation = () => {
        setCloseInformation(false)
    };
    return (
      <div className="task-context">
        <button className="pai-button-in-theory" onClick={() => askAboutTask(task_number, code)}>
            pai <span className="arrow-in-theory">></span>
        </button>
        {close_information && (
            <div className="task-context-information">
                Задача добавлена к контексту pai! Если обновишь код, нажми на кнопку еще раз!
                <button className="close-information" onClick={closeInformation}>
                    ✖
                </button>
            </div>
        )}
      </div>
    );
}

export default TaskContextInTheory;
